module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"All deposit notices"},"et":{"title":"All deposit notices"},"ru":{"title":"All deposit notices"}}')
  delete Component.options._Ctor
}
